<script lang="ts">
	import { Route } from "svelte-routing"
	import type { Component } from "svelte"

	import LoadingPage from "../loaders/LoadingPage.svelte"
	import { pageInit } from "../../../modules/page-events/initPage"
	import { getCurrentUser } from "../../../stores/UserStore"

	interface Props {
		path: string
		component: Component<any>
	}

	let { path, component }: Props = $props()

	let isLoading = $state(true)

	function redirect() {
		location.replace("/login")
	}

	async function onRouteMount() {
		const isUserLoggedIn = await pageInit.initPageLoad(true)

		// if the user isn't logged in or is not an admin, redirect to the login page
		if (!isUserLoggedIn || !getCurrentUser().hasPriv("admin")) return redirect()

		isLoading = false
	}
</script>

<Route {path}>
	{#snippet children({ params })}
		{#if isLoading}
			<LoadingPage {onRouteMount} />
		{:else}
			{@const SvelteComponent_1 = component}
			<SvelteComponent_1 {params} />
		{/if}
	{/snippet}
</Route>

<style>
</style>
